import { LOCALE_ID, NgModule, inject, provideAppInitializer, provideZonelessChangeDetection } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';

import { DatePipe, DecimalPipe, registerLocaleData } from '@angular/common';
import localeDe from '@angular/common/locales/de';
import localeEn from '@angular/common/locales/en';
import { environment } from '../environments/environment';
import { ServiceWorkerModule } from '@angular/service-worker';
import { MatTabsModule } from '@angular/material/tabs';
import { FormsModule } from '@angular/forms';
import { MatCardModule } from '@angular/material/card';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatDialogModule } from '@angular/material/dialog';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { AccountService } from './services/account.service';
import { HeaderComponent } from './components/header/header.component';
import { LangSegmentComponent } from './components/header/lang-segment/lang-segment.component';
import { StartPageComponent } from './components/start-page/start-page.component';
import { RecommendationsComponent } from './components/recommendations/recommendations.component';
import { ActivatedRoute, Router } from '@angular/router';
import { ValidationResultDialogComponent } from './shared/modals/validation-result-dialog/validation-result-dialog.component';
import { ErrorDialogComponent } from './shared/modals/error-dialog/error-dialog.component';
import { IosInstallDialogComponent } from './shared/modals/ios-install-dialog/ios-install-dialog.component';
import { EINVOICE_PROCESSING_ENGINE, EinvoiceViewerModule, INVOICE_SERVICE_CONFIG } from 'projects/einvoice-viewer/src/public-api';
import { Processor, PROCESSOR_CONFIG } from 'projects/einvoice-viewer/src/lib/services/processor.service';
import { ServiceWorkerUpdateService } from './services/service-worker-update.service';

registerLocaleData(localeDe);
registerLocaleData(localeEn);

@NgModule({ declarations: [
        AppComponent,
        HeaderComponent,
        StartPageComponent,
        ErrorDialogComponent,
        IosInstallDialogComponent,
        ValidationResultDialogComponent
    ],
  bootstrap: [AppComponent],
  imports: [BrowserModule,
        AppRoutingModule,
        BrowserAnimationsModule,
        MatTabsModule,
        MatCardModule,
        MatProgressBarModule,
        FormsModule,
        MatIconModule,
        MatButtonModule,
        MatSnackBarModule,
        MatDialogModule,
        MatTableModule,
        MatTooltipModule,
        MatCheckboxModule,
        EinvoiceViewerModule,
        LangSegmentComponent,
        RecommendationsComponent,
        ServiceWorkerModule.register('ngsw-worker.js', {
            enabled: environment.serviceWorker,
            // Register the ServiceWorker as soon as the app is stable
            // or after 30 seconds (whichever comes first).
            registrationStrategy: 'registerWhenStable:30000',
        })], providers: [
        {
            provide: LOCALE_ID,
            useFactory: (accountService: AccountService) => accountService.Locale,
            deps: [AccountService],
        },
        provideAppInitializer(() => {
        const initializerFn = ((accountService: AccountService) => {
                return async () => {
                    await accountService.init();
                };
            })(inject(AccountService));
        return initializerFn();
      }),
        provideAppInitializer(() => {
        inject(ServiceWorkerUpdateService).init();
      }),
        DecimalPipe, DatePipe,
        provideHttpClient(withInterceptorsFromDi()),
        {
            provide: PROCESSOR_CONFIG,
            useValue: { formatsPath: 'assets/formats' }
        },
        {
            provide: EINVOICE_PROCESSING_ENGINE,
            useExisting: Processor
        },
        {
            provide: INVOICE_SERVICE_CONFIG,
            useValue: {
                pdfWorkerPath: './assets/pdfjs/pdf.worker.min.mjs'
            }
        },
        provideZonelessChangeDetection()
    ] })
export class AppModule { }
